import axios, {AxiosResponse, AxiosError} from 'axios'
import { getLocalStorageValue, deleteLocalStorageValue } from '../utils/localStorage.utils'

const api = axios.create({
    baseURL: "http://localhost:4001/auth",
})

api.interceptors.response.use(
    async (response: AxiosResponse) => {
      // Handle response data
      return response;
    },
    async (error: AxiosError) => {
      // Handle error
      if (error.response?.status === 400) {
        // Redirect to login if session expired
        alert('Session Expirée')
        deleteLocalStorageValue('ac_token')
        window.location.href = '/';
      }
      return Promise.reject(error);
    },
);


const login = async(wallet: string, signature: string, message: string, date: string) => {
    try {
        const response: AxiosResponse = await api.post("/login", {
            wallet: wallet,
            signature: signature,
            message: message,
            date: date
        })
        return response.data;
    }
    catch(error) {
        console.log(error)
        return Promise.reject(error)
    }
}

const logout = async () => {
    try {
        const token = getLocalStorageValue("ac_token")
        if(!token) return;
        const response : AxiosResponse = await api.post("/logout",{
            token : token,
        });
        deleteLocalStorageValue("ac_token")
        return response.data
    }
    catch(error) {
        console.log(error)
        return Promise.reject(error);
    }

}

const isLogin = async () => {
    try {
        const token = getLocalStorageValue("ac_token");
        if(!token) return Promise.reject();
        const response = await api.post("/isLogin",{
            token : token,
        })
        
        return response
        
    }
    catch(error) {
       console.log(error)
       return Promise.reject(error)
    }
}

const authService = {login,logout,isLogin}

export default authService;
